(function () {
  "use strict";

  var t = {
    114: function _(t, e, r) {
      var _n,
          i = this && this.__extends || (_n = function n(t, e) {
        return (_n = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
          }
        })(t, e);
      }, function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");

        function r() {
          this.constructor = t;
        }

        _n(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      }),
          a = this && this.__awaiter || function (t, e, r, n) {
        return new (r || (r = Promise))(function (i, a) {
          function o(t) {
            try {
              c(n.next(t));
            } catch (t) {
              a(t);
            }
          }

          function s(t) {
            try {
              c(n.throw(t));
            } catch (t) {
              a(t);
            }
          }

          function c(t) {
            var e;
            t.done ? i(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
              t(e);
            })).then(o, s);
          }

          c((n = n.apply(t, e || [])).next());
        });
      },
          o = this && this.__generator || function (t, e) {
        var r,
            n,
            i,
            a,
            o = {
          label: 0,
          sent: function sent() {
            if (1 & i[0]) throw i[1];
            return i[1];
          },
          trys: [],
          ops: []
        };
        return a = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
          return this;
        }), a;

        function s(a) {
          return function (s) {
            return function (a) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; o;) {
                try {
                  if (r = 1, n && (i = 2 & a[0] ? n.return : a[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, a[1])).done) return i;

                  switch (n = 0, i && (a = [2 & a[0], i.value]), a[0]) {
                    case 0:
                    case 1:
                      i = a;
                      break;

                    case 4:
                      return o.label++, {
                        value: a[1],
                        done: !1
                      };

                    case 5:
                      o.label++, n = a[1], a = [0];
                      continue;

                    case 7:
                      a = o.ops.pop(), o.trys.pop();
                      continue;

                    default:
                      if (!((i = (i = o.trys).length > 0 && i[i.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                        o = 0;
                        continue;
                      }

                      if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                        o.label = a[1];
                        break;
                      }

                      if (6 === a[0] && o.label < i[1]) {
                        o.label = i[1], i = a;
                        break;
                      }

                      if (i && o.label < i[2]) {
                        o.label = i[2], o.ops.push(a);
                        break;
                      }

                      i[2] && o.ops.pop(), o.trys.pop();
                      continue;
                  }

                  a = e.call(t, o);
                } catch (t) {
                  a = [6, t], n = 0;
                } finally {
                  r = i = 0;
                }
              }

              if (5 & a[0]) throw a[1];
              return {
                value: a[0] ? a[1] : void 0,
                done: !0
              };
            }([a, s]);
          };
        }
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var s = r(240),
          c = r(746),
          u = r(275),
          d = r(463),
          l = r(742),
          f = r(754),
          p = function (t) {
        function e() {
          return null !== t && t.apply(this, arguments) || this;
        }

        return i(e, t), e.prototype.createSwapScript = function (t) {
          this.validateSwapParams(t);
          var e = l.remove0x(d.addressToString(t.recipientAddress)),
              r = l.remove0x(d.addressToString(t.refundAddress)),
              n = t.expiration.toString(16),
              i = c.padHexStart(n, 5),
              a = ["60", "c8", "80", "60", "0b", "60", "00", "39", "60", "00", "f3", "60", "20", "80", "60", "00", "80", "37", "60", "21", "81", "60", "00", "80", "60", "02", "60", "48", "f1", "36", "60", "20", "14", "16", "7f", t.secretHash, "60", "21", "51", "14", "16", "60", "4f", "57", "36", "15", "64", i, "42", "11", "16", "60", "8c", "57", "fe", "5b", "7f", "8c1d64e3bd87387709175b9ef4e7a1d7a8364559fc0e2ad9d77953909a0d1eb3", "60", "20", "60", "00", "a1", "73", e, "ff", "5b", "7f", "5d26862916391bf49478b2f5103b0720a842b45ef145a268f2cd1fb2aed55178", "60", "00", "80", "a1", "73", r, "ff"].join("").toLowerCase();
          if (422 !== Buffer.byteLength(a)) throw new Error("Invalid swap script. Bytecode length incorrect.");
          return a;
        }, e.prototype.validateSwapParams = function (t) {
          d.validateValue(t.value), l.validateAddress(t.recipientAddress), l.validateAddress(t.refundAddress), d.validateSecretHash(t.secretHash), l.validateExpiration(t.expiration);
        }, e.prototype.initiateSwap = function (t, e) {
          return a(this, void 0, void 0, function () {
            var r;
            return o(this, function (n) {
              return this.validateSwapParams(t), r = this.createSwapScript(t), [2, this.client.chain.sendTransaction({
                to: null,
                value: t.value,
                data: r,
                fee: e
              })];
            });
          });
        }, e.prototype.fundSwap = function () {
          return a(this, void 0, void 0, function () {
            return o(this, function (t) {
              return [2, null];
            });
          });
        }, e.prototype.claimSwap = function (t, e, r, n) {
          return a(this, void 0, void 0, function () {
            var i;
            return o(this, function (a) {
              switch (a.label) {
                case 0:
                  return this.validateSwapParams(t), d.validateSecret(r), d.validateSecretAndHash(r, t.secretHash), [4, this.verifyInitiateSwapTransaction(t, e)];

                case 1:
                  return a.sent(), [4, this.getMethod("getTransactionReceipt")(e)];

                case 2:
                  if (!(i = a.sent())) throw new f.PendingTxError("Transaction receipt is not available: " + e);
                  return [4, this.getMethod("assertContractExists")(i.contractAddress)];

                case 3:
                  return a.sent(), [2, this.client.chain.sendTransaction({
                    to: i.contractAddress,
                    value: new u.BigNumber(0),
                    data: r,
                    fee: n
                  })];
              }
            });
          });
        }, e.prototype.refundSwap = function (t, e, r) {
          return a(this, void 0, void 0, function () {
            var n;
            return o(this, function (i) {
              switch (i.label) {
                case 0:
                  return this.validateSwapParams(t), [4, this.verifyInitiateSwapTransaction(t, e)];

                case 1:
                  return i.sent(), [4, this.getMethod("getTransactionReceipt")(e)];

                case 2:
                  if (!(n = i.sent())) throw new f.PendingTxError("Transaction receipt is not available: " + e);
                  return [4, this.getMethod("assertContractExists")(n.contractAddress)];

                case 3:
                  return i.sent(), [2, this.client.chain.sendTransaction({
                    to: n.contractAddress,
                    value: new u.BigNumber(0),
                    data: "",
                    fee: r
                  })];
              }
            });
          });
        }, e.prototype.doesTransactionMatchInitiation = function (t, e) {
          var r = this.createSwapScript(t);
          return null === e._raw.to && l.remove0x(e._raw.input) === r && t.value.eq(l.hexToNumber(e._raw.value));
        }, e.prototype.doesTransactionMatchClaim = function (t, e) {
          return d.caseInsensitiveEqual(t._raw.to, e.contractAddress) && 64 === l.remove0x(t._raw.input).length;
        }, e.prototype.verifyInitiateSwapTransaction = function (t, e) {
          return a(this, void 0, void 0, function () {
            var r, n;
            return o(this, function (i) {
              switch (i.label) {
                case 0:
                  return this.validateSwapParams(t), [4, this.getMethod("getTransactionByHash")(e)];

                case 1:
                  if (!(r = i.sent())) throw new f.TxNotFoundError("Transaction not found: " + e);
                  return [4, this.getMethod("getTransactionReceipt")(e)];

                case 2:
                  if (!(n = i.sent())) throw new f.PendingTxError("Transaction receipt is not available: " + e);
                  return [2, this.doesTransactionMatchInitiation(t, r) && n.contractAddress && "0x1" === n.status];
              }
            });
          });
        }, e.prototype.findSwapTransaction = function (t, e) {
          return a(this, void 0, void 0, function () {
            var r;
            return o(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, this.getMethod("getBlockByNumber")(t, !0)];

                case 1:
                  if (!(r = n.sent())) throw new f.BlockNotFoundError("Block not found: " + t);
                  return r ? [2, r.transactions.find(function (t) {
                    return e(t, r);
                  })] : [2];
              }
            });
          });
        }, e.prototype.findInitiateSwapTransaction = function (t, e) {
          return a(this, void 0, void 0, function () {
            var r = this;
            return o(this, function (n) {
              return this.validateSwapParams(t), [2, this.findSwapTransaction(e, function (e) {
                return r.doesTransactionMatchInitiation(t, e);
              })];
            });
          });
        }, e.prototype.findClaimSwapTransaction = function (t, e, r) {
          return a(this, void 0, void 0, function () {
            var n,
                i,
                a,
                s,
                c = this;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  return this.validateSwapParams(t), [4, this.getMethod("getTransactionReceipt")(e)];

                case 1:
                  if (!(n = o.sent())) throw new f.PendingTxError("Transaction receipt is not available: " + e);
                  return [4, this.findSwapTransaction(r, function (t) {
                    return c.doesTransactionMatchClaim(t, n);
                  })];

                case 2:
                  return (i = o.sent()) ? [4, this.getMethod("getTransactionReceipt")(i.hash)] : [2];

                case 3:
                  return (a = o.sent()) && "0x1" === a.status ? [4, this.getSwapSecret(i.hash)] : [3, 5];

                case 4:
                  return s = o.sent(), d.validateSecretAndHash(s, t.secretHash), i.secret = s, [2, i];

                case 5:
                  return [2];
              }
            });
          });
        }, e.prototype.findFundSwapTransaction = function () {
          return a(this, void 0, void 0, function () {
            return o(this, function (t) {
              return [2, null];
            });
          });
        }, e.prototype.getSwapSecret = function (t) {
          return a(this, void 0, void 0, function () {
            var e;
            return o(this, function (r) {
              switch (r.label) {
                case 0:
                  return [4, this.getMethod("getTransactionByHash")(t)];

                case 1:
                  return e = r.sent(), [2, l.remove0x(e._raw.input)];
              }
            });
          });
        }, e.prototype.findRefundSwapTransaction = function (t, e, r) {
          return a(this, void 0, void 0, function () {
            var n;
            return o(this, function (i) {
              switch (i.label) {
                case 0:
                  return this.validateSwapParams(t), [4, this.getMethod("getTransactionReceipt")(e)];

                case 1:
                  if (!(n = i.sent())) throw new f.PendingTxError("Transaction receipt is not available: " + e);
                  return [4, this.findSwapTransaction(r, function (e, r) {
                    return d.caseInsensitiveEqual(e._raw.to, n.contractAddress) && "0x" === e._raw.input && r.timestamp >= t.expiration;
                  })];

                case 2:
                  return [2, i.sent()];
              }
            });
          });
        }, e;
      }(s.Provider);

      e.default = p;
    },
    175: function _(t, e, r) {
      var n = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.EthereumSwapProvider = void 0;
      var i = n(r(114));
      e.EthereumSwapProvider = i.default;
    },
    746: function _(t) {
      t.exports = require("@liquality/crypto");
    },
    754: function _(t) {
      t.exports = require("@liquality/errors");
    },
    742: function _(t) {
      t.exports = require("@liquality/ethereum-utils");
    },
    240: function _(t) {
      t.exports = require("@liquality/provider");
    },
    275: function _(t) {
      t.exports = require("@liquality/types");
    },
    463: function _(t) {
      t.exports = require("@liquality/utils");
    }
  },
      e = {},
      r = function r(n) {
    var i = e[n];
    if (void 0 !== i) return i.exports;
    var a = e[n] = {
      exports: {}
    };
    return t[n].call(a.exports, a, a.exports, r), a.exports;
  }(175);

  module.exports = r;
})();